// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Opog","barChart":"barChart__3ja-9","tooltipDonors":"tooltipDonors__2sMKq","tooltipDisplay":"tooltipDisplay__M2Z2E","displayTextWrapper":"displayTextWrapper__18A3F","title":"title__3_fvR","donorName":"donorName__1EYWa","contribution":"contribution__3_5LE","innerChartWrapper":"innerChartWrapper__1XvfE","regular":"regular__3V0KP","other":"other__1KbQa","mobile_responsive":"mobile_responsive__2kQeN","donorFlag":"donorFlag__3pPvc","donorLegendMobile":"donorLegendMobile__1aCZD","donorLegend":"donorLegend__3-k1Q","desktop_responsive":"desktop_responsive__20_Wr"};


//////////////////
// WEBPACK FOOTER
// ./components/stackedBarChart2/barElement/style.scss
// module id = Lztf
// module chunks = 0